import React, { memo } from 'react';
import { Tab, Tabs } from 'appkit-react';
// import '@style/components/tabs.scss';
import '../../styles/components/tabs.scss';
//import PropTypes from 'prop-types';
function TabComp(props) {
  const {
    defaultValue,
    tabs,
    className,
    onChange,
    isSingleCompany,
    destroyInactiveTabPane = false,
  } = props;
  return (
    <Tabs
      defaultValue={defaultValue}
      className={`a-tab-item-padding-10 ${className || ''} ${
        isSingleCompany && 'is-single-company'
      }`}
      onChange={onChange}
      destroyInactiveTabPane={destroyInactiveTabPane}
    >
      {(tabs || []).map((item, index) => (
        <Tab key={index} value={String(index)} label={item.label}>
          {item.children ? item.children : null}
        </Tab>
      ))}
    </Tabs>
  );
}

export default memo(TabComp);
